import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { invalidateSolarFinancingLockReaders } from "./solar-financing-lock-readers"
import type {
  SolarCreditHumanAttemptBody,
  SolarCreditHumanHandoffDto,
} from "../dto/solar-proposal-financing.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/**
 * Apply for Credit Human financing from the exact current Quote. A retry with
 * the same idempotency key returns the same attempt and handoff URL.
 */
export default function useApplySolarCreditHuman(): UseMutationResult<
  SolarCreditHumanHandoffDto,
  unknown,
  { proposalId: string; body: SolarCreditHumanAttemptBody }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId, body }) =>
      solarProposalService.applyCreditHuman(proposalId, body),
    // Fire and forget: the handoff tab waits on this mutation, so it must not
    // also wait on unrelated refetches.
    onSettled: (_data, _error, { proposalId }) => {
      invalidateSolarFinancingLockReaders(queryClient, proposalId)
    },
  })
}
